module.exports = __webpack_public_path__ + "img/cz.25a519bd.jpg";